import i18next from '@i18n';

declare global {
    interface Date {
        toLocalRegularDateTime(): string;
        toLocalInputDate(): string;
    }
    interface String {
        toLocalRegularDateTime(): string;
        toCamelCase(): string;
        toLocalInputDate(): string;
        toLocalInputDateTime(): string;
        getNameInitials(): string;
        toCountryDisplayName(): string | undefined;
    }
    interface Number {
        toCurrencyString(lang: string, currency: string): string;
    }
}

Date.prototype.toLocalRegularDateTime = function (): string {
    return this.toLocaleString(undefined, {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
    });
};

Date.prototype.toLocalInputDate = function (): string {
    return this.toISOString().split('T')[0];
};

String.prototype.toLocalRegularDateTime = function (): string {
    return new Date(this).toLocalRegularDateTime();
};

String.prototype.toCamelCase = function (): string {
    return this.toLowerCase().replace(/\b[a-z]/g, char => char.toUpperCase());
};

String.prototype.toLocalInputDate = function (): string {
    return new Date(this).toISOString().split('T')[0];
};

String.prototype.toLocalInputDateTime = function (): string {
    return new Date(this).toISOString().slice(0, 16);
};

String.prototype.getNameInitials = function (): string {
    return this.split(' ')
        .slice(0, 2)
        .map(name => name[0])
        .join('');
};

String.prototype.toCountryDisplayName = function (): string | undefined {
    try {
        return new Intl.DisplayNames([i18next.language], { type: 'region' }).of(
            this,
        );
    } catch (error) {
        if (error instanceof RangeError) {
            return undefined;
        }
        throw error;
    }
};

Number.prototype.toCurrencyString = function (
    lang: string,
    currency: string,
): string {
    return this.toLocaleString(lang, {
        currency: currency,
        style: 'currency',
    });
};

export {};
